import { relationshipAvailability } from '../lib/engine.js';
import { timePlan } from '../lib/life.js';
import { GROUP_LABEL } from '../lib/rules.js';
import './life-scenes.css';

/** 관계 요청 선택지. 상태 변경은 엔진에서 처리한다. */
export default function RelationshipModal({ run, offer, focusUnits = 0, focusField, onFocusFieldChange, onFocusUnitsChange, onResolve }) {
  const person = (run.people ?? []).find((q) => q.id === offer.personId);
  const availability = person ? relationshipAvailability(run, person) : null;
  const plan = timePlan(run, { focus: focusField, focusUnits });
  const remaining = Math.max(0, plan.capacity - plan.used);
  const canShare = availability?.available !== false;
  const field = GROUP_LABEL[offer.field] ?? offer.field, own = GROUP_LABEL[offer.ownField] ?? '내 일';
  const options = [
    { kind: 'help', label: offer.duePromise ? '약속한 일을 함께한다' : '함께한다', cost: 2,
      detail: `${field}↑ 신뢰↑` },
    { kind: 'limited', label: '범위를 줄여 돕는다', cost: 1,
      detail: `${field} 조금↑ ${own} 조금↑ 신뢰 조금↑` },
    { kind: 'decline', label: offer.duePromise ? '이번 약속을 지키지 못한다고 말한다' : '이번에는 거절한다', cost: 0,
      detail: offer.duePromise ? '신뢰↓ 약속 미이행으로 기록' : `${own}↑ (그 시간에 내 일을 함) · 신뢰 변화 없음` },
  ];

  return (
    <div className="overlay">
      <div className="card modal relationship-modal" role="dialog" aria-modal="true" aria-labelledby="relationship-offer-title">
        <div className="row" style={{ alignItems: 'center', margin: 0 }}>
          <span className="agechip">{run.age}세</span>
          <span className="muted">{offer.duePromise ? '약속을 확인할 때' : '함께할 일'}</span>
          <div className="grow" /><span className="chip">{offer.personName}</span>
        </div>
        <h2 id="relationship-offer-title">{offer.title}</h2>
        <p className="muted relationship-description">{offer.description}</p>
        {availability && !canShare && <p className="relationship-availability unavailable"><b>{availability.label}</b><span>{availability.reason}</span></p>}
        <div className="relationship-choices">
          {options.map((choice, i) => {
            const disabled = choice.cost > remaining || (choice.cost > 0 && !canShare);
            const reason = choice.cost > remaining ? '올해는 더 하기 어렵다' : !canShare && choice.cost > 0 ? '올해는 일정이 맞지 않는다' : null;
            return (
              <button type="button" key={choice.kind} className="choice" disabled={disabled}
                onClick={() => onResolve({ kind: choice.kind, offer })}>
                <span className="num">{i + 1}</span>
                <span className="grow choice-copy"><b>{choice.label}</b><small>{choice.detail}</small>{reason && <small>{reason}</small>}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
